<div class="py-1"></div>
<div class="card">
  <h6 class="card-header" style="cursor: pointer" (click)="showNewPhoneNumberForm = !showNewPhoneNumberForm"><i class="fas" [ngClass]="{ 'fa-plus-circle': !showNewPhoneNumberForm, 'fa-minus-circle': showNewPhoneNumberForm }"></i>&nbsp;New Phone Number</h6>
  <div class="card-body" [hidden]="!showNewPhoneNumberForm" style="max-height: 340px; overflow-y: scroll">
    <app-phone-number-form [contactId]="contactId" (saved)="formSaved($event)"></app-phone-number-form>
  </div>
</div>
<div class="py-1"></div>
<div class="float-right">
  <button type="button" [disabled]="loadingPhoneNumbers" (click)="loadPhoneNumbers()" class="btn btn-outline-primary btn-sm">
    <i class="fas fa-redo fa-fw" [ngClass]="{ 'fa-spin': loadingPhoneNumbers }"></i>
  </button>
</div>
<div class="clearfix"></div>
<div class="py-1"></div>
<table class="table table-sm">
  <tbody [appNativeSortableJs]="phoneNumbers" [sortableOptions]="sortableOptions">
    <tr *ngFor="let phoneNumber of phoneNumbers; let i = index">
      <td *ngIf="!phoneNumber.editing" [title]="phoneNumber.notes">
        <div class="alias-sort-handle d-inline-block py-1 px-2" style="cursor: grab" title="Sort">
          <i class="fas fa-random"></i>
        </div>
        <a appPhoneCallBilling phoneCallContactName="" [href]="'tel:' + phoneNumber.number" title="Call {{ phoneNumber.number }}"><i class="fas fa-phone fa-xs"></i>&nbsp;{{ phoneNumber.number }}</a>
        <span *ngIf="phoneNumber.notes">
          <br />
          <i class="text-muted">{{ phoneNumber.notes }}</i>
        </span>
        <br />
        <div class="btn-group btn-group-sm">
          <button title="Edit" (click)="phoneNumber.editing = true" type="button" class="btn btn-outline-primary btn-sm">
            <i class="fas fa-pencil-alt"></i>
          </button>
          <button title="Delete" (click)="deletePhoneNumber(phoneNumber, i)" type="button" class="btn btn-outline-danger btn-sm">
            <i class="fas fa-trash"></i>
          </button>
        </div>
      </td>
      <td *ngIf="!phoneNumber.editing" [title]="phoneNumber.notes">
        {{ phoneNumber.extension }}
      </td>
      <td *ngIf="!phoneNumber.editing" [title]="phoneNumber.notes">
        {{ phoneNumber.phone_type_name }}
      </td>
      <td colspan="3" *ngIf="phoneNumber.editing">
        <h6 class="font-italic text-info">Editing Phone Number</h6>
        <app-phone-number-form [phoneNumber]="phoneNumber" (saved)="formSaved($event, phoneNumber)"></app-phone-number-form>
      </td>
    </tr>
  </tbody>
</table>
<ng-template #confirmDeleteModal let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title">Confirm deletion</h4>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p>{{ deleteWarningMessage }}</p>
    <div *ngIf="alternatePhoneNumbers && alternatePhoneNumbers.length > 0">
      <b>Choose an alternative phone number to replace with:</b>
      <div class="custom-control custom-radio" *ngFor="let alternatePhoneNumber of alternatePhoneNumbers" (click)="selectAlternatePhoneNumber(alternatePhoneNumber)">
        <input name='alternate_phone_number_id' ngDefaultControl type="radio" name="alternate_phone_number_id" class="custom-control-input" [checked]="alternatePhoneNumber.checked" />
        <label class="custom-control-label" for="alternate_phone_number_id">{{ alternatePhoneNumber.label }}</label>
      </div>
    </div>
    <div *ngIf="!alternatePhoneNumbers || alternatePhoneNumbers.length < 1">
      <b>No alternative phone numbers found</b>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="c('Delete')">Confirm delete</button>
    <button type="button" class="btn btn-secondary" (click)="d('Cancel')">Cancel</button>
  </div>
</ng-template>
